import { EditorAPIKey, CompPointersApiKey } from '#packages/apis';
import { createLayoutApi } from './createLayoutApi';
import { LayoutApiKey } from './publicApiKey';

import type { EntryPoint } from '#packages/apilib';

export const LayoutEntrypoint: EntryPoint = {
  name: 'LayoutApi',
  declareAPIs: () => [LayoutApiKey],
  getDependencyAPIs: () => [EditorAPIKey, CompPointersApiKey],
  attach(shell) {
    shell.contributeAPI(LayoutApiKey, () => createLayoutApi(shell));
  },
};

export * from './$layoutY';
export { ensureCompRefOrRefsHasValue } from './layoutGetApi/validation';

export type { LayoutMoveByInterceptor } from './layoutMoveApi';
export type {
  AttachCandidateStatus,
  AttachCandidateResponse,
  LayoutFullWidthValue,
  LayoutFullWidthSiteMargin,
} from './type';
